import React from 'react';
import LoadingSpinner from '../../../../../../../common/src/components/LoadingSpinner';
import CompanyScanAppShell from './CompanyScanAppShell';

const CompanyScanLoading: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <CompanyScanAppShell>
      <LoadingSpinner id="COMPANY-SCAN_APP-SHELL_LOADING" />
    </CompanyScanAppShell>
  );
};

export default CompanyScanLoading;
